import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { IMonitoringReportWebJobsResponse } from 'src/app/shared/interfaces';
import { Component, DestroyRef, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { constructionProject } from '@igniteui/material-icons-extended';
import { IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { DataService } from 'src/app/core/services/data/data.service';
import { MessageDialogService } from 'src/app/core/services/helper/message-dialog.service';
import { IgxPreventDocumentScrollModule } from 'src/app/shared/directives/prevent-scroll.directive';
import { HeaderTitleLotDataComponent } from 'src/app/shared/ui/header-title-lot-data/header-title-lot-data.component';

@Component({
  selector: 'app-report-webjobs-status',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    IgxGridModule,
    IgxGridComponent,
    IgxPreventDocumentScrollModule,
    HeaderTitleLotDataComponent,
    CurrencyPipe,
  ],
  templateUrl: './report-webjobs-status.component.html',
  styleUrl: './report-webjobs-status.component.scss'
})
export class ReportWebjobsStatusComponent {

    jobReportData: IMonitoringReportWebJobsResponse[] = [];

    //Services
    private dataService = inject(DataService);
    public _appGeneralState = inject(AppGeneralStateService);
    private _destroyRefService = inject(DestroyRef);
    _messageService = inject(MessageDialogService);
    _snackBar = inject(MatSnackBar);
    _dialog = inject(MatDialog);
    _datePipe = inject(DatePipe);
    private readonly router = inject(Router);
    showPinnedRow: boolean = false;
    startDate: string = '9-1-2026';
    displayLocalTime: boolean = true;

    webJobsForm = new FormGroup({
      reportDate: new FormControl(this.getDefaultReportStartDate(), [Validators.required]),
    });

      constructor() {
        this.onSubmitAsOfWebJobsDataFetch();
      }

    private getDefaultReportStartDate(): Date {
      const defaultDate = new Date();
      defaultDate.setDate(defaultDate.getDate() - 7);
      return defaultDate;
    }

    onSubmitAsOfWebJobsDataFetch(): void {
      const theStartDate: string = this._datePipe.transform(this.webJobsForm.value.reportDate, 'M-d-yyyy') ?? '';
      this.dataService.getMonitoringWebJobsTaskListByStartDate(theStartDate ).subscribe({
        next: (data) => {
          this.jobReportData = data;
          this.transReportDateTime();
          
        },
        error: (error) => {
          this.jobReportData = [];
        },
      });
    }

    transReportDateTime(): void {
      if(this.displayLocalTime){
        this.jobReportData = this.jobReportData.map(item => {
          return {
            ...item,
            jobStartDateTimeUtc: this.normalizeUtcDateString(item.jobStartDateTimeUtc) ?? item.jobStartDateTimeUtc,
            jobFinishDateTimeUtc: this.normalizeUtcDateString(item.jobFinishDateTimeUtc),
            lastSuccessfulRunDateUtc: this.normalizeUtcDateString(item.lastSuccessfulRunDateUtc),
          };
        });
      }
    }

    // .NET UTC timestamps arrive without a 'Z' suffix, so append one before parsing to avoid double-conversion; the date pipe then renders it in local time
    private normalizeUtcDateString(value: string | null): string | null {
      if (!value) {
        return value;
      }
      const utcValue = value.endsWith('Z') ? value : `${value}Z`;
      return new Date(utcValue).toISOString();
    }
}
